export default __webpack_public_path__ + "static/media/logoJotaauto.a9f13de3.jpg";